import style from "./ResultPopUp.module.css";
import crossButton from "../../assets/crossButton.svg";
import { useState } from "react";
import { ChartComponent } from "../ChartComponent/ChartComponent";



export const ResultPopUpCard = (props) => {
    const { fusionCrossSectionCalculator, setPhysicalConstData, resultIsLoading, setResultIsLoading, showResultPopUp, setShowResultPopUp, physicalConstData } = props;
    const [ecm, setEcm] = useState()
    const periodicTable= {
        1:"H",
        2:"He",
        3:"Li",
        4:"Be",
        5:"B",
        6:"C",
        7:"N",
        8:"O",
        9:"F",
        10:"Ne",
        11:"Na",
        12:"Mg",
        13:"Al",
        14:"Si",
        15:"P",
        16:"S",
        17:"Cl",
        18:"Ar",
        19:"K",
        20:"Ca",
        21:"Sc",
        22:"Ti",
        23:"V",
        24:"Cr",
        25:"Mn",
        26:"Fe",
        27:"Co",
        28:"Ni",
        29:"Cu",
        30:"Zn",
        31:"Ga",
        32:"Ge",
        33:"As",
        34:"Se",
        35:"Br",
        36:"Kr",
        37:"Rb",
        38:"Sr",
        39:"Y",
        40:"Zr",
        41:"Nb",
        42:"Mo",
        43:"Tc",
        44:"Ru",
        45:"Rh",
        46:"Pd",
        47:"Ag",
        48:"Cd",
        49:"In",
        50:"Sn",
        51:"Sb",
        52:"Te",
        53:"I",
        54:"Xe",
        55:"Cs",
        56:"Ba",
        57:"La",
        58:"Ce",
        59:"Pr",
        60:"Nd",
        61:"Pm",
        62:"Sm",
        63:"Eu",
        64:"Gd",
        65:"Tb",
        66:"Dy",
        67:"Ho",
        68:"Er",
        69:"Tm",
        70:"Yb",
        71:"Lu",
        72:"Hf",
        73:"Ta",
        74:"W",
        75:"Re",
        76:"Os",
        77:"Ir",
        78:"Pt",
        79:"Au",
        80:"Hg",
        81:"Tl",
        82:"Pb",
        83:"Bi",
        84:"Po",
        85:"At",
        86:"Rn",
        87:"Fr",
        88:"Ra",
        89:"Ac",
        90:"Th",
        91:"Pa",
        92:"U",
        93:"Np",
        94:"Pu",
        95:"Am",
        96:"Cm",
        97:"Bk",
        98:"Cf",
        99:"Es",
        100:"Fm",
        101:"Md",
        102:"No",
        103:"Lr",
        104:"Rf",
        105:"Db",
        106:"Sg",
        107:"Bh",
        108:"Hs",
        109:"Mt",
        110:"Ds",
        111:"Rg",
        112:"Cn",
        113:"Nh",
        114:"Fl",
        115:"Mc",
        116:"Lv",
        117:"Ts",
        118:"Og",
        119:"119",
        120:"120",
        121:"121",
        122:"122",
        123:"123",
        124:"124",
        125:"125",
        126:"126",
        127:"127",
        128:"128",
        129:"129",
        130:"130",
        131:"131",
        132:"132",
        133:"133",
        134:"134",
        135:"135",
        136:"136",
        137:"137",
        138:"138",
        139:"139",
        140:"140",
        141:"141",
        142:"142",
        143:"143",
        144:"144",
        145:"145",
        146:"146",
        147:"147",
        148:"148",
        149:"149",
        150:"150",
        151:"151",
        152:"152",
        153:"153",
        154:"154",
        155:"155",
        156:"156",
        157:"157",
        158:"158",
        159:"159",
        160:"160",
        161:"161",
        162:"162",
        163:"163",
        164:"164",
        165:"165",
        166:"166",
        167:"167",
        168:"168",
        169:"169",
        170:"170",
        171:"171",
        172:"172",
        173:"173",
        174:"174",
        175:"175",
        176:"176",
        177:"177",
        178:"178",
        179:"179",
        180:"180",
        181:"181",
        182:"182",
        183:"183",
        184:"184",
        185:"185",
        186:"186",
        187:"187",
        188:"188",
        189:"189",
        190:"190",
        191:"191",
        192:"192",
        193:"193",
        194:"194",
        195:"195",
        196:"196",
        197:"197",
        198:"198",
        199:"199",
        200:"200",
        201:"201",
        202:"202",
        203:"203",
        204:"204",
        205:"205",
        206:"206",
        207:"207",
        208:"208",
        209:"209",
        210:"210",
        211:"211",
        212:"212",
        213:"213",
        214:"214",
        215:"215",
        216:"216",
        217:"217",
        218:"218",
        219:"219",
        220:"220",
        221:"221",
        222:"222",
        223:"223",
        224:"224",
        225:"225",
        226:"226",
        227:"227",
        228:"228",
        229:"229",
        230:"230",
        231:"231",
        232:"232",
        233:"233",
        234:"234",
        235:"235",
        236:"236",
        237:"237",
        238:"238",
        239:"239",
        240:"240",
        241:"241",
        242:"242",
        243:"243",
        244:"244",
        245:"245",
        246:"246",
        247:"247",
        248:"248",
        249:"249",
        250:"250",
        251:"251",
        252:"252",
        253:"253",
        254:"254",
        255:"255",
        256:"256",
        257:"257",
        258:"258",
        259:"259",
        260:"260",
        261:"261",
        262:"262",
        263:"263",
        264:"264",
        265:"265",
        266:"266",
        267:"267",
        268:"268",
        269:"269",
        270:"270",
        271:"271",
        272:"272",
        273:"273",
        274:"274",
        275:"275",
        276:"276",
        277:"277",
        278:"278",
        279:"279",
        280:"280",
        281:"281",
        282:"282",
        283:"283",
        284:"284",
        285:"285",
        286:"286",
        287:"287",
        288:"288",
        289:"289",
        290:"290",
        291:"291",
        292:"292",
        293:"293",
        294:"294",
        295:"295",
        296:"296",
        297:"297",
        298:"298",
    }
    const handleCalculateFusion = (ecmCal) => {
        fusionCrossSectionCalculator(Number(physicalConstData?.ap),Number(physicalConstData?.zp),Number(physicalConstData?.at),Number(physicalConstData?.zt),Number(physicalConstData?.vb), Number(physicalConstData?.rb), Number(physicalConstData?.hw), Number(ecmCal))
    }
    console.log(physicalConstData.entChannels)
    return(
        <>
        <div className={style.resultPopUpCardContainer}>
            <div className={style.popUpInnerContainer}>
                <div className={style.crossBtnContainer} onClick={()=> setShowResultPopUp(false)}>
                    <img src={crossButton} />
                </div>
                {
                    resultIsLoading?
                    <div className="">

                    </div>
                    :
                    <div className="" style={{width:"100%"}}>
                        <div className="">
                         <span className={style.title}>   Evaluated Values are</span>
                         <br/>
                        {<div className={style.equationContainer}><sup>{ physicalConstData?.ap}</sup><span> {periodicTable?.[physicalConstData?.zp]}</span>+<sup>{physicalConstData?.at}</sup><span> {periodicTable?.[physicalConstData?.zt]}</span><span>{"->"}</span><sup> {physicalConstData?.ac}</sup> <span>{periodicTable?.[physicalConstData?.zc]}</span></div>}
                    <div className={style.contentsContainer}>
                        <div className={style.potentialsContainer}>
                            <table className={style.table}>
                                <tbody className={style.tBody}>
                                    <tr className={style.constantsTableRow}>
                                        <th>Zc :</th>
                                        <td>{physicalConstData?.zc}</td>
                                    </tr>
                                    <tr>
                                        <th>Ac :</th>
                                        <td>{physicalConstData?.ac}</td>
                                    </tr><tr>
                                        <th>Vb :</th>
                                        <td>{physicalConstData?.vb==("NA"|| null)?physicalConstData?.vb : physicalConstData?.vb.toFixed(3)+"MeV"}</td>
                                    </tr><tr>
                                        <th>Rb :</th>
                                        <td>{physicalConstData?.hw==("NA"|| null)?physicalConstData?.rb : physicalConstData?.rb.toFixed(3)+"fm"}</td>
                                    </tr>
                                    <tr>
                                        <th>hw :</th>
                                        <td>{physicalConstData?.hw==("NA"|| null)?physicalConstData?.hw : physicalConstData?.hw.toFixed(3)+"MeV"}</td>
                                    </tr>
                                    <tr>
                                        <th>Bf :</th>
                                        <td>{physicalConstData?.bf==("NA"|| null)?physicalConstData?.bf : physicalConstData?.bf.toFixed(3)+"Mev"}</td>
                                    </tr>
                                </tbody>
                            </table>
                            {/* <div className={style.deformationsTable}>
                                <div className={style.title}>
                                    Deformation Parameters :
                                </div>
                                <div className="">
                                    <table className={style.deformationTableContainer}>
                                        <tr>
                                            <th></th>
                                            <th>b2</th>
                                            <th>b3</th>
                                            <th>b4</th>
                                            <th>b6</th>
                                        </tr>
                                        <tr>
                                            <th>Projectile</th>
                                            <td>{physicalConstData?.beta2p==("NA"|| null)?physicalConstData?.beta2p: physicalConstData?.beta2p.toFixed(5)}</td>
                                            <td>{physicalConstData?.beta3p==("NA"|| null)?physicalConstData?.beta3p: physicalConstData?.beta3p.toFixed(5)}</td>
                                            <td>{physicalConstData?.beta4p==("NA"|| null)?physicalConstData?.beta4p: physicalConstData?.beta4p.toFixed(5)}</td>
                                            <td>{physicalConstData?.beta6p==("NA"|| null)?physicalConstData?.beta6p: physicalConstData?.beta6p.toFixed(5)}</td>
                                        </tr>
                                        <tr>
                                            <th>Target</th>
                                            <td>{physicalConstData?.beta2t==("NA"|| null)?physicalConstData?.beta2t: physicalConstData?.beta2t.toFixed(5)}</td> 
                                            <td>{physicalConstData?.beta3t==("NA"|| null)?physicalConstData?.beta3t: physicalConstData?.beta3t.toFixed(5)}</td> 
                                            <td>{physicalConstData?.beta4t==("NA"|| null)?physicalConstData?.beta4t: physicalConstData?.beta4t.toFixed(5)}</td> 
                                            <td>{physicalConstData?.beta6t==("NA"|| null)?physicalConstData?.beta6t: physicalConstData?.beta6t.toFixed(5)}</td> 
                                        </tr>
                                        <tr>
                                            <th>Compound Nuclei</th>
                                            <td>{physicalConstData?.beta2c==("NA"|| null)?physicalConstData?.beta2c: physicalConstData?.beta2c.toFixed(5)}</td> 
                                            <td>{physicalConstData?.beta3c==("NA"|| null)?physicalConstData?.beta3c: physicalConstData?.beta3c.toFixed(5)}</td> 
                                            <td>{physicalConstData?.beta4c==("NA"|| null)?physicalConstData?.beta4c: physicalConstData?.beta4c.toFixed(5)}</td> 
                                            <td>{physicalConstData?.beta6c==("NA"|| null)?physicalConstData?.beta6c: physicalConstData?.beta6c.toFixed(5)}</td> 
                                        </tr>
                                    </table>
                                </div>
                            </div> */}
                            <div className={style.deformationsTable}>
                                <div className={style.title}>
                                    Entrance Channel Parameters :
                                </div>
                                <div className="">
                                    <table className={style.deformationTableContainer}>

                                        <tr>
                                            <th>z</th>
                                            <td>{physicalConstData?.entChannels?.z==("NA"|| null)?physicalConstData?.entChannels?.z: physicalConstData?.entChannels?.z.toFixed(4)}</td>
                                        </tr>
                                        <tr>
                                            <th>X<sub>m</sub></th>
                                            <td>{physicalConstData?.entChannels?.xm==("NA"|| null)?physicalConstData?.entChannels?.xm: physicalConstData?.entChannels?.xm.toFixed(4)}</td>
                                        </tr>
                                        <tr>
                                            <th>α<sub>Z</sub></th><td>{physicalConstData?.entChannels?.az==("NA"|| null)?physicalConstData?.entChannels?.az: physicalConstData?.entChannels?.az.toFixed(4)}</td>
                                        </tr>
                                        <tr>
                                            <th>η<sub>A</sub></th>
                                            <td>{physicalConstData?.entChannels?.nA==("NA"|| null)?physicalConstData?.entChannels?.nA: physicalConstData?.entChannels?.nA.toFixed(4)}</td>
                                        </tr>
                                        <tr>
                                            <th>Δ(N/Z)</th><td>{physicalConstData?.entChannels?.dnz==("NA"|| null)?physicalConstData?.entChannels?.dnz: physicalConstData?.entChannels?.dnz.toFixed(4)}</td>
                                        </tr>
                                        <tr>
                                            <th>Z<sub>1</sub>Z<sub>2</sub></th>
                                            <td>{physicalConstData?.entChannels?.z1z2==("NA"|| null)?physicalConstData?.entChannels?.z1z2: physicalConstData?.entChannels?.z1z2.toFixed(0)}</td>
                                        </tr>
                                        <tr>
                                            <th>isospin</th>
                                            <td>{physicalConstData?.entChannels?.dnzn==("NA"|| null)?physicalConstData?.entChannels?.dnzn: physicalConstData?.entChannels?.dnzn.toFixed(4)}</td>
                                        </tr>
                                        <tr>
                                            <th>Z<sup>2</sup>/A</th>
                                            <td>{physicalConstData?.entChannels?.zsqa==("NA"|| null)?physicalConstData?.entChannels?.zsqa: physicalConstData?.entChannels?.zsqa.toFixed(4)}</td>
                                        </tr>
                                    </table>
                                </div>
                            </div>

                        </div>
                        <div className={style.fusionCrossSections}>
                           <div className={style.ecmInput}><span className={style.title}>Please enter the Ecm for fusion cross section</span> <div className={style.inputForFusion}><input className={style.inputBox} placeholder="Ecm" value={ecm} onChange={ (e) => setEcm(e.target.value) }/> <button className={style.fusionCrossSectionCalBtn} onClick={()=>handleCalculateFusion(ecm)}>Calculate</button></div></div>
                                <div className={style.title}>
                                    Fusion Cross Section :
                                </div>
                            <div>
                                {physicalConstData?.fusionCross==("NA"|| null)?null : 
                                    <table className={style.fusionCrossSectionsTable}>
                                        <tr>
                                            <th>Ecm (MeV)</th>
                                            <th>sfu(mb)</th>
                                        </tr>
                                        {
                                            physicalConstData?.fusionCross?.map((ele) =>{
                                                return<tr>
                                                    <td>{ele.ecm}</td>
                                                    <td>{ele.sfu}</td>
                                                </tr>
                                            })
                                        }
                                    </table>
                                }
                            </div>
                        </div>
                        {physicalConstData?.fusionCross?.length>0&&<div className={style.graphContainer}>
                            <ChartComponent fusionCrossSections={physicalConstData?.fusionCross} vb={physicalConstData?.vb}/>
                        </div>}
                    </div>
                </div>
            </div>
                }
            </div>
        </div>
        </>
    )
}